<template>
  <RichTextEditor :value="value"
                  :placeholder="placeholder"
                  :rows="rows"
                  :qid="qid"
                  :headings="false"
                  :compact="true"
                  @input="$emit('input', $event)"/>
</template>

<script>
import RichTextEditor from '@/components/richText/RichTextEditor.vue';

// Text field for task notes, testing notes, control description, performed test, conclusion and the
// client's comment: bold, italic and underline (US 9390), and bulleted, numbered and lettered lists (US 9394).
// No headers. v-model holds the format described in components/richText/richText.js.
export default {
  name: 'FormattedNoteEditor',
  components: {
    RichTextEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 5
    },
    qid: {
      type: String,
      default: null
    }
  }
};
</script>
